<template>
  <md-field class="md-invalid">
    <div class="isis-date-time-input w-full">
      <input
        type="datetime-local"
        :value="value"
        @input="$emit('input', $event.target.value)"
        class="w-full h-full bg-transparent"
      />

      <div class="w-full h-full flex items-center">
        <label>{{ $t(label) }}</label>
        <md-input
          type="text"
          v-model="valueDateTime"
          :required="required"
        ></md-input>
        <md-icon>today</md-icon>
        <span class="md-error" v-if="required && !value">
          {{ $t("validation.required_field") }}
        </span>
        <slot></slot>
      </div>
    </div>
  </md-field>
</template>

<script>
import moment from "moment";

export default {
  name: "isis-date-time-picker",
  props: {
    label: String,
    value: String,
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valueDateTime: moment(this.value).format("DD/MM/YYYY HH:mm") // default input: current date
    };
  },
  watch: {
    value(newValue) {
      this.valueDateTime = newValue
        ? moment(newValue).format("DD/MM/YYYY HH:mm")
        : "";
    }
  }
};
</script>

<style lang="scss" scoped>
.isis-date-time-input {
  position: relative;
  cursor: pointer;
  min-width: 123px;

  input[type="datetime-local"] {
    position: absolute;
    display: inline-block;
    top: 0;
    left: 0;
    z-index: 1;
    cursor: pointer;

    &::-webkit-datetime-edit {
      display: none;
    }

    &::-webkit-calendar-picker-indicator {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: auto;
      height: auto;
      color: transparent;
      background: transparent;
      cursor: pointer;
    }
  }
}
</style>
